import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import viewComponent from './GroupMembersBox';
import initActionsCreator from './redux/initModule';

export const getWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-17-groups.svg',
    title: t('widgets.group_members.addButtonHeader'),
    description: t('widgets.group_members.description'),
  },
  initActionsCreator,
});

export default getWidgetConfig;
